<fgbcl-errors></fgbcl-errors>

<div class="form-group">
  <button (click)="loginTM()" class="btn btn-primary login-button font-size-14 fw-bold w-100 d-flex align-items-center justify-content-center">
    <span class="text-white">Login with</span>
    <img [src]="'providers/ticketmaster' | contentAssetImage" alt="Ticketmaster" class="tm-logo-btn ms-2" />
  </button>
</div>
